import { render, staticRenderFns } from "./InsuranceAcceptance.vue?vue&type=template&id=abb4d048&scoped=true"
import script from "./InsuranceAcceptance.vue?vue&type=script&lang=js"
export * from "./InsuranceAcceptance.vue?vue&type=script&lang=js"
import style0 from "./InsuranceAcceptance.vue?vue&type=style&index=0&id=abb4d048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb4d048",
  null
  
)

export default component.exports